import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";

import logo from "../../assests/images/scaldlogo.png";

export default function Header() {
    return (
        <header className="header">
            <div className="container">
                <div className="headerRow">
                    <Link to="/" className="logo">
                        <img src={logo} alt="Logo" />
                    </Link>
                    <Navbar />
                </div>
            </div>
        </header>
    );
}
